import { confirmOpenedNotifications } from "@/app/notification-taps"
import { registerEasyMatchSync } from "@/entities/easy-match"
import { registerFriendSync } from "@/entities/friend"
import { stackedNotificationIds } from "@/entities/notification"
import { registerScenarioEvents } from "@/entities/scenario"
import { registerStreamEvents } from "@/entities/stream"
import { registerVoiceEvents } from "@/entities/voice-message"
import {
	handleNotification,
	wsBridge,
	wsStore,
	wsUserId,
} from "@/shared/api/websocket"
import { keepPendingSystemNotifications } from "@/shared/lib/platform"
import "./register-notifications"

// The stack is empty until the server has finished replaying what is still
// outstanding, so the shade is swept only after the burst goes quiet: every
// message pushes the deadline back, a disconnect cancels it. Sweeping at connect
// would clear every push the app has not caught up with yet.
const SHADE_SWEEP_DELAY_MS = 3000
let shadeSweep: ReturnType<typeof setTimeout> | undefined

function scheduleShadeSweep(): void {
	clearTimeout(shadeSweep)
	shadeSweep = setTimeout(() => {
		void keepPendingSystemNotifications(stackedNotificationIds())
	}, SHADE_SWEEP_DELAY_MS)
}

function cancelShadeSweep(): void {
	clearTimeout(shadeSweep)
	shadeSweep = undefined
}

export function registerSubscriptions(): void {
	registerFriendSync()
	registerEasyMatchSync()
	registerScenarioEvents()
	registerVoiceEvents()
	registerStreamEvents()

	const { router } = wsBridge.getContext()
	if (router) {
		router.subscribe("onResolved", () => confirmOpenedNotifications(router))
	}

	wsStore.on("state", ({ isConnected }) => {
		if (!isConnected) {
			cancelShadeSweep()
			return
		}
		if (wsUserId()) scheduleShadeSweep()
	})

	wsBridge.subscribe("notification", (payload, queryClient, router) => {
		scheduleShadeSweep()
		const userId = wsUserId()
		if (!userId) return

		handleNotification(payload, { queryClient, router, userId })
		confirmOpenedNotifications(router)
	})
}
